import interk from "../../../assets/svg/Intertek.svg";
import browser from "../../../assets/svg/browser.svg";
import cloud from "../../../assets/svg/cloud.svg";
import galaSecure from "../../../assets/svg/secure.svg";
import ndaa from "../../../assets/svg/ndda.svg";
import ul from "../../../assets/svg/ul.svg";
import can_ulc from "../../../assets/svg/can_ulc.svg";
export const featuresData = [
  {
    id: 1,
    title: "UL 294 Listed",
    image: interk,
  },

  {
    id: 3,
    title: "NDAA Compliant",
    image: ndaa,
  },
  {
    id: 2,
    title: "Browser Managed",
    image: browser,
  },
  // {
  //   id: 4,
  //   title: "Scalable Infrastructure",
  //   image: solar,
  // },
  {
    id: 5,
    title: "Cloud Management",
    image: cloud,
  },
  {
    id: 6,
    title: "Ensure Your Safety",
    image: galaSecure,
  },
  {
    id: 10,
    title: "UL",
    image: ul,
  },
  {
    id: 11,
    title: "CAN_ULC",
    image: can_ulc,
  },
  // {
  //   id: 7,
  //   title: "Low total cost of ownership",
  //   image: doller,
  // },
  // {
  //   id: 8,
  //   title: "Multiple User Privileges",
  //   image: multipleUser,
  // },
];
